<template>
  <div class="largerVersion">
    <div class="largerVersionbox" @click="back">
      <div
        v-if="$padFalg.indexOf('u3d') != -1 && largerImgList.length > 1"
        class="pre"
        @click.stop="preTap"
      >
        <i></i>
      </div>
      <div
        v-if="$padFalg.indexOf('u3d') != -1 && largerImgList.length > 1"
        class="next"
        @click.stop="nextTap"
      >
        <i></i>
      </div>
      <div class="largerVersion_topnum">{{ currnum }}/{{ totalnum }}</div>
      <van-swipe
        ref="largerVersionSwipe"
        class="my-swipe"
        indicator-color="white"
        :show-indicators="false"
        @change="onChange"
      >
        <van-swipe-item
          v-for="item in largerImgList"
          class="imgbox"
          :key="item.id"
        >
          <!-- <viewer :images="[...item.path]"> -->
            <img :src="item.path" />
          <!-- </viewer> -->
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>
<script>
export default {
  name: "largerVersion",
  props: {
    largerImgList: {
      type: Array,
      default: () => [],
    },
    currindex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      false: false,
      true: true,
      imglist: [],
      currnum: this.currindex + 1,
      totalnum: this.largerImgList.length,
    };
  },
  mounted() {
    this.swipeTo();
  },
  methods: {
    //左右切换
    nextTap() {
      this.$refs.largerVersionSwipe.next();
    },
    preTap() {
      this.$refs.largerVersionSwipe.prev();
    },
    //切换到指定位置
    swipeTo() {
      this.$refs.largerVersionSwipe.swipeTo(this.currindex, {
        immediate: this.true,
      });
    },
    //获取当前索引
    onChange(index) {
      this.currnum = index + 1;
    },
    back() {
      this.$emit("imgClick", false);
    },
  },
};
</script>
<style scoped>
.largerVersion {
  /* position: relative; */
}
</style>